import { render, staticRenderFns } from "./yetkilendirmeler.vue?vue&type=template&id=3e0e2b18&scoped=true&"
import script from "./yetkilendirmeler.vue?vue&type=script&lang=js&"
export * from "./yetkilendirmeler.vue?vue&type=script&lang=js&"
import style0 from "./yetkilendirmeler.vue?vue&type=style&index=0&id=3e0e2b18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0e2b18",
  null
  
)

export default component.exports